import { Calendar as CalendarIcon } from 'lucide-react';
import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BankHolidaysSection = () => {
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHolidays = async () => {
      try {
        const response = await axios.get(`${API}/holidays/uk`);
        setHolidays(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching holidays:', error);
        setLoading(false);
      }
    };
    fetchHolidays();
  }, []);

  return (
    <div className="content-card" data-testid="holidays-section">
      <div className="card-header">
        <h2>
          <CalendarIcon size={20} className="inline" /> UK Bank Holidays
        </h2>
      </div>
      <div className="card-content">
        {loading ? (
          <p className="loading-text">Loading...</p>
        ) : (
          <div className="holidays-list">
            {holidays.length > 0 ? (
              holidays.map((holiday, index) => (
                <div key={`${holiday.date}-${holiday.name}`} className="holiday-item" data-testid={`holiday-${index}`}>
                  <div className="holiday-date">{holiday.date}</div>
                  <div className="holiday-name">{holiday.name}</div>
                  <div className="holiday-countdown">
                    {holiday.days_away === 0 ? 'Today!' : 
                     holiday.days_away === 1 ? 'Tomorrow' : 
                     `In ${holiday.days_away} days`}
                  </div>
                </div>
              ))
            ) : (
              <p className="no-data">No upcoming holidays</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BankHolidaysSection;